import { render, staticRenderFns } from "./AppointOrderSelector.vue?vue&type=template&id=615c5758&scoped=true&"
import script from "./AppointOrderSelector.vue?vue&type=script&lang=js&"
export * from "./AppointOrderSelector.vue?vue&type=script&lang=js&"
import style0 from "./AppointOrderSelector.vue?vue&type=style&index=0&id=615c5758&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c5758",
  null
  
)

export default component.exports